<template>
  <!-- Overlay pour mobile -->
  <div class="mobile-overlay" :class="{ 'show': open }" @click="$emit('toggle')"></div>
  
  <aside class="sidebar" :class="{ 'open': open }">
    <div class="sidebar-header">
      <div class="logo-container">
        <img :src="tenantStore.logoUrl || '@/assets/images/opsolver-logo.png'" :alt="tenantStore.tenantName" class="sidebar-logo" />
        <div v-if="open" class="logo-text">{{ tenantStore.tenantName }}</div>
      </div>
      <button class="toggle-btn" @click="$emit('toggle')">
        <span class="material-icons">{{ open ? 'chevron_left' : 'chevron_right' }}</span>
      </button>
    </div>

    <nav class="sidebar-nav">
      <router-link to="/dashboard" class="nav-link" active-class="active">
        <span class="material-icons">dashboard</span>
        <span v-if="open" class="nav-text">Tableau de bord</span>
      </router-link>

      <div class="nav-item has-submenu" :class="{ 'active': isPersonnelActive, 'open': isPersonnelOpen || isPersonnelActive }" @click="togglePersonnelMenu">
        <div class="nav-link">
          <span class="material-icons">people</span>
          <span v-if="open" class="nav-text">Personnel</span>
          <span v-if="open" class="material-icons submenu-icon" :class="{ 'rotate': isPersonnelOpen || isPersonnelActive }">expand_more</span>
        </div>
        <div v-show="(open && (isPersonnelOpen || isPersonnelActive))" class="submenu">
          <router-link to="/personnel" class="submenu-link" active-class="active">
            <span class="material-icons">list_alt</span>
            <span v-if="open" class="nav-text">Liste & Statistiques</span>
          </router-link>
          <!-- <router-link to="/personnel/cartes" class="submenu-link" active-class="active">
            <span class="material-icons">badge</span>
            <span v-if="open" class="nav-text">Cartes imprimées</span>
          </router-link> -->
          <!--
          <router-link to="/personnel/conges" class="submenu-link" active-class="active">
            <span class="material-icons">beach_access</span>
            <span v-if="open" class="nav-text">Gestion des congés</span>
          </router-link>
          <router-link to="/personnel/conges/quotas" class="submenu-link" active-class="active">
            <span class="material-icons">event_note</span>
            <span v-if="open" class="nav-text">Quotas de congés</span>
          </router-link>
          <router-link to="/personnel/conges/calendrier" class="submenu-link" active-class="active">
            <span class="material-icons">calendar_month</span>
            <span v-if="open" class="nav-text">Calendrier des congés</span>
          </router-link>
          <router-link to="/personnel/missions" class="submenu-link" active-class="active">
            <span class="material-icons">flight_takeoff</span>
            <span v-if="open" class="nav-text">Missions</span>
          </router-link>
          <router-link to="/personnel/archives" class="submenu-link" active-class="active">
            <span class="material-icons">archive</span>
            <span v-if="open" class="nav-text">Archivages</span>
          </router-link>
          -->
        </div>
        
        <!-- Dropdown hover pour sidebar fermée -->
        <div class="hover-dropdown">
          <div class="dropdown-header">Personnel</div>
          <router-link to="/personnel" class="dropdown-link">
            <span class="material-icons">list_alt</span>
            <span class="dropdown-text">Liste & Statistiques</span>
          </router-link>
          <router-link to="/personnel/cartes" class="dropdown-link">
            <span class="material-icons">badge</span>
            <span class="dropdown-text">Cartes imprimées</span>
          </router-link>
        </div>
      </div>

      <div class="nav-item has-submenu" :class="{ 'active': isPointageActive, 'open': isPointageOpen || isPointageActive }" @click="togglePointageMenu">
        <div class="nav-link">
          <span class="material-icons">fact_check</span>
          <span v-if="open" class="nav-text">Pointage</span>
          <span v-if="open" class="material-icons submenu-icon" :class="{ 'rotate': isPointageOpen || isPointageActive }">expand_more</span>
        </div>
        <div v-show="(open && (isPointageOpen || isPointageActive))" class="submenu">
          <router-link to="/pointage/calendrier" class="submenu-link" active-class="active">
            <span class="material-icons">calendar_month</span>
            <span v-if="open" class="nav-text">Calendrier</span>
          </router-link>
          <router-link to="/shifts" class="submenu-link" active-class="active">
            <span class="material-icons">schedule</span>
            <span v-if="open" class="nav-text">Shifts</span>
          </router-link>
          <router-link to="/shifts/assignment" class="submenu-link" active-class="active">
            <span class="material-icons">assignment_ind</span>
            <span v-if="open" class="nav-text">Assignation des Shifts</span>
          </router-link>
          <router-link to="/pointage/sites-assignment" class="submenu-link" active-class="active">
            <span class="material-icons">place</span>
            <span v-if="open" class="nav-text">Assignation des Sites</span>
          </router-link>
        </div>
        
        <!-- Dropdown hover pour sidebar fermée -->
        <div class="hover-dropdown">
          <div class="dropdown-header">Pointage</div>
          <router-link to="/pointage/calendrier" class="dropdown-link">
            <span class="material-icons">calendar_month</span>
            <span class="dropdown-text">Calendrier</span>
          </router-link>
          <router-link to="/shifts" class="dropdown-link">
            <span class="material-icons">schedule</span>
            <span class="dropdown-text">Shifts</span>
          </router-link>
          <router-link to="/shifts/assignment" class="dropdown-link">
            <span class="material-icons">assignment_ind</span>
            <span class="dropdown-text">Assignation des Shifts</span>
          </router-link>
          <router-link to="/pointage/sites-assignment" class="dropdown-link">
            <span class="material-icons">place</span>
            <span class="dropdown-text">Assignation des Sites</span>
          </router-link>
        </div>
      </div>

      <div class="nav-spacer"></div>
      
      <router-link to="/parametres" class="nav-link settings-link" active-class="active">
        <span class="material-icons">settings</span>
        <span v-if="open" class="nav-text">Paramètres</span>
      </router-link>
    </nav>

    <div class="sidebar-footer">
      <button class="logout-btn" @click="handleLogout">
        <span class="material-icons">logout</span>
        <span v-if="open" class="btn-text">Se déconnecter</span>
      </button>
    </div>
  </aside>
</template>

<script setup>
import { useAuthStore } from '@/store/auth'
import { useTenantStore } from '@/stores/tenant'
import { useRouter, useRoute } from 'vue-router'
import { ref, computed, watch, onMounted } from 'vue'

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  }
})

defineEmits(['toggle'])

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const tenantStore = useTenantStore()

// État pour les sous-menus
const isPointageOpen = ref(false)
const isPersonnelOpen = ref(false)

// État pour les tooltips et menus contextuels
const showPersonnelTooltip = ref(false)
const showPointageTooltip = ref(false)
const activeTooltip = ref(null)

// Initialiser le store tenant au montage
onMounted(async () => {
  if (!tenantStore.isInitialized) {
    await tenantStore.loadConfig()
  }
})

// Vérifie si la route active est liée à Pointage ou Personnel
const isPointageActive = computed(() => {
  return route.path.startsWith('/pointage')
})

const isPersonnelActive = computed(() => {
  return route.path.startsWith('/personnel')
})

// Ouvre/ferme le menu Pointage
const togglePointageMenu = () => {
  isPointageOpen.value = !isPointageOpen.value
}

// Ouvre/ferme le menu Personnel
const togglePersonnelMenu = () => {
  isPersonnelOpen.value = !isPersonnelOpen.value
}

// Ces fonctions ne sont plus nécessaires avec la nouvelle approche CSS

// Ferme les sous-menus quand la sidebar se ferme
watch(() => props.open, (isOpen) => {
  if (!isOpen) {
    isPointageOpen.value = false
    isPersonnelOpen.value = false
  }
})

const handleLogout = () => {
  authStore.logout()
  router.push('/login')
}
</script>

<style scoped>
/* Import des variables de couleurs OpSolver */
@import '@/assets/css/variables.css';


/* Overlay mobile */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(2px);
  display: none;
}

.mobile-overlay.show {
  opacity: 1;
  visibility: visible;
}

.sidebar {
  height: 100%;
  background-color: var(--turquoise-dark);
  color: white;
  width: 64px;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar.open {
  width: 250px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  min-height: 64px;
  background: linear-gradient(135deg, var(--turquoise-dark) 0%, rgba(0, 150, 136, 0.95) 100%);
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-logo {
  height: 32px;
  width: 32px;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.logo-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.3;
  color: white;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}

.sidebar.open .logo-text {
  opacity: 1;
  transform: translateX(0);
}

.toggle-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  backdrop-filter: blur(10px);
}

.toggle-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.sidebar-nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}

/* Styles pour les items principaux et sous-menus */
.nav-item {
  position: relative;
  margin-bottom: 4px;
  cursor: pointer;
}

.nav-item .nav-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: background-color 0.3s;
  border-left: 3px solid transparent;
  white-space: nowrap;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: background-color 0.3s;
  border-left: 3px solid transparent;
  margin-bottom: 4px;
  white-space: nowrap;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.submenu-icon {
  transition: transform 0.3s ease;
  font-size: 18px;
  margin-left: auto;
}

.submenu-icon.rotate {
  transform: rotate(180deg);
}

.submenu {
  overflow: hidden;
  transition: height 0.3s ease;
  background-color: rgba(0, 0, 0, 0.1);
  border-left: 3px solid rgba(255, 255, 255, 0.1);
  margin-left: 0;
  width: 100%;
  box-sizing: border-box;
}

.submenu-link {
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 24px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: background-color 0.3s;
  white-space: nowrap;
  font-size: 0.95em;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.submenu-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.submenu-link.active {
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  font-weight: 500;
}

.nav-item.active > .nav-link,
.nav-link:hover,
.nav-link.active {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-item.active > .nav-link,
.nav-link.active {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border-left: 3px solid var(--turquoise-light);
}

.nav-text {
  margin-left: 16px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}

.sidebar-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.user-info {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}

.user-role {
  font-weight: 600;
  font-size: 14px;
}

.user-type {
  font-size: 12px;
  opacity: 0.8;
}

.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  transition: all 0.3s ease;
}

.nav-spacer {
  height: 20px;
  margin: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.settings-link {
  margin-top: 5px;
}

.sidebar:not(.open) .logout-btn {
  padding: 8px;
}

.sidebar:not(.open) .material-icons {
  margin: 0 auto;
}

.logout-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.btn-text {
  margin-left: 8px;
  white-space: nowrap;
}

/* Responsivité avancée */
@media (max-width: 1024px) {
  .sidebar {
    width: 60px;
  }
  
  .sidebar.open {
    width: 240px;
  }
  
  .sidebar-header {
    min-height: 75px;
    padding: 18px 12px;
  }
  
  .sidebar-logo {
    height: 36px;
    margin-bottom: 6px;
  }
  
  .logo-text {
    font-size: clamp(10px, 2.5vw, 12px);
    max-width: 180px;
  }
}

@media (max-width: 768px) {
  
  .mobile-overlay {
    display: block;
  }
  
  .sidebar {
    position: fixed;
    transform: translateX(-100%);
    width: 280px;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.4);
    z-index: 1000;
  }

  .sidebar.open {
    transform: translateX(0);
  }
  
  .sidebar-header {
    padding: 20px 16px;
    min-height: 72px;
  }
  
  .sidebar-logo {
    height: 36px;
    width: 36px;
  }
  
  .logo-text {
    font-size: 16px;
    max-width: 180px;
  }
  
  .toggle-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }
  
  /* Agrandir les zones de clic sur mobile */
  .nav-link {
    padding: 16px;
    font-size: 16px;
  }
  
  .submenu-link {
    padding: 14px 16px 14px 32px;
    font-size: 15px;
  }
  
  .nav-text {
    margin-left: 12px;
  }
  
  .sidebar-header {
    padding: 20px 16px;
  }
  
  .sidebar-logo {
    height: 36px;
  }
  
  .logo-text {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  
  .sidebar {
    width: 100vw;
    border-radius: 0;
  }
  
  .sidebar-header {
    padding: 16px;
    min-height: 64px;
  }
  
  .sidebar-logo {
    height: 32px;
    width: 32px;
  }
  
  .logo-text {
    font-size: 15px;
  }
  
  .toggle-btn {
    width: 32px;
    height: 32px;
  }
}

/* Hover dropdown pour les sous-menus en mode sidebar fermée */
.nav-item.has-submenu {
  position: relative;
}

.hover-dropdown {
  position: absolute;
  left: calc(100% + 8px);
  top: 0;
  background: linear-gradient(135deg, var(--turquoise-dark) 0%, rgba(0, 150, 136, 0.95) 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
  min-width: 240px;
  z-index: 1500;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-10px) translateY(-5px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  pointer-events: none;
  backdrop-filter: blur(10px);
}

/* Afficher le dropdown au survol uniquement quand la sidebar est fermée */
.sidebar:not(.open) .nav-item.has-submenu:hover .hover-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateX(0) translateY(0);
  pointer-events: auto;
}

.dropdown-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.dropdown-link {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.dropdown-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.dropdown-link.active {
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  font-weight: 500;
}

.dropdown-text {
  margin-left: 12px;
  font-size: 14px;
}

/* Ajustements pour les écrans moyens */
@media (max-width: 1024px) {
  .hover-dropdown {
    left: 60px;
  }
}

@media (max-width: 1200px) and (min-width: 769px) {
  .hover-dropdown {
    left: 58px;
  }
}

/* Améliorations pour les petits écrans desktop */
@media (max-width: 1200px) and (min-width: 769px) {
  .sidebar {
    width: 58px;
  }
  
  .sidebar.open {
    width: 230px;
  }
}

/* Animations plus fluides */
.sidebar,
.sidebar * {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Scroll personnalisé pour la navigation */
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  transition: background 0.3s ease;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}
</style>